const createFeatureCollection = <T extends GeoJSON.Geometry, P>(
  features: GeoJSON.Feature<T, P>[] = []
): GeoJSON.FeatureCollection<T, P> => ({
  type: "FeatureCollection",
  features,
});

export default createFeatureCollection;
